import React, { useState } from 'react';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Personnel from './pages/Personnel';
import Alerts from './pages/Alerts';
import Analytics from './pages/Analytics';
import './App.css';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import SOS from './pages/SOS';

function App() {
  const [activePage, setActivePage] = useState('dashboard');

  const renderPage = () => {
    switch (activePage) {
      case 'dashboard': return <Dashboard />;
      case 'personnel': return <Personnel />;
      case 'alerts': return <Alerts />;
      case 'analytics': return <Analytics />;
      case 'sos': return <SOS />;
      case 'reports': return <Reports />;
      case 'settings': return <Settings />;
      default: return <Dashboard />;
    }
  };

  return (
    <div className="app">
      <Header alertCount={4} onMenuToggle={() => {}} onNavigate={setActivePage} />
      <div className="app-body">
        <Sidebar active={activePage} onChange={setActivePage} />
        <main className="app-main">
          {renderPage()}
        </main>
      </div>
      <div className="made-in-footer">
        <span>🏛️ Smart Baton – Vijayawada City Police</span>
        <span className="footer-sep">|</span>
        <span className="ap-badge">Made in Andhra Pradesh</span>
        <span className="footer-sep">|</span>
        <span>© 2026 Andhra Pradesh Police Department</span>
      </div>
    </div>
  );
}

export default App;